import { useRltConfirmationDeleteMutation } from "@/services/backend/rlt/confirmations/api/confirmation-api";
import { useToast } from "@/shared/hooks/use-toast";
import { useNavigate } from "react-router";
import { useEffect } from "react";
import t from "@/lang/lang";
import { Button } from "@/shared/components/ui/button";
import { Trash2 } from "lucide-react";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";

export function DeleteConfirmationDialog(props: { confirmationId: string }) {
  const { confirmationId } = props;
  const [deleteConfirmation, { isLoading, isSuccess, error, reset }] =
    useRltConfirmationDeleteMutation();
  const { toast } = useToast();
  const navigate = useNavigate();

  const onClick = () => {
    if (isLoading) {
      return;
    }
    deleteConfirmation({ id: confirmationId });
  };

  useEffect(() => {
    if (isSuccess) {
      toast({
        title: t("Bestätigung gelöscht"),
        variant: "success",
      });
      navigate(`..`);
      reset();
    }
  }, [isSuccess, navigate, reset, toast]);

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button type="button" variant="outline">
          <Trash2 className="h-5 w-5" />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("Auftragsbestätigung wirklich löschen")}</DialogTitle>
        </DialogHeader>
        <RTKQueryErrorAlert error={error} />
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">{t("Abbrechen")}</Button>
          </DialogClose>
          <Button onClick={onClick} variant="destructive">
            {t("Löschen")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
